module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZAQAAAADskrjOAAAAGElEQVR42mNAAzKoBHMDCiHD/wCJoBgAAIvqBP/9+1luAAAAAElFTkSuQmCC"